/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ListProjectsStatus } from './listProjectsStatus';
import type { ListProjectsStatusNot } from './listProjectsStatusNot';
import type { ListProjectsVisibility } from './listProjectsVisibility';
import type { ListProjectsVisibilityNot } from './listProjectsVisibilityNot';

export type ListProjectsParams = {
search?: string | null;
status?: ListProjectsStatus;
status_not?: ListProjectsStatusNot;
visibility?: ListProjectsVisibility;
visibility_not?: ListProjectsVisibilityNot;
selector?: 'my' | null;
creator_id?: string | null;
creator_id_not?: string | null;
/**
 * @minimum 1
 */
page?: number;
/**
 * @minimum 1
 * @maximum 100
 */
per_page?: number;
};
